import { render, staticRenderFns } from "./ElCard.vue?vue&type=template&id=4f6134b8"
import script from "./ElCard.vue?vue&type=script&lang=js"
export * from "./ElCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports